import {CampusSelectorProps} from "@/app/(withHeaderAndFooter)/(sellPages)/courses/course/components/CampusSelector";
import {faChevronDown} from "@fortawesome/sharp-regular-svg-icons/faChevronDown";
import {faLocationDot} from "@fortawesome/sharp-regular-svg-icons/faLocationDot";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import FilterDropdownButton from "@/app/_components/FilterDropdownButton";

const CurrentCampuses = ({
	currentCampuses,
	allCampusesById,
}: Pick<CampusSelectorProps, "currentCampuses" | "allCampusesById">) => {
	const [currentCampusId] = currentCampuses;
	const campus = allCampusesById[currentCampusId];
	if (!currentCampusId) {
		return <span>Select Campus</span>;
	}
	return <span>{campus.city}</span>;
};

const CampusSelectorButton: React.FC<
	Omit<CampusSelectorProps, "setCurrentCampuses">
> = ({currentCampuses, allCampusesById, buttonProps}) => {
	return (
		// Less padding on right here since the icons are unbalanced
		<FilterDropdownButton
			className="pr-5"
			aria-controls="campus-selector-menu"
			onPress={buttonProps?.onPress}
		>
			<FontAwesomeIcon icon={faLocationDot} />
			<CurrentCampuses
				currentCampuses={currentCampuses}
				allCampusesById={allCampusesById}
			/>
			<FontAwesomeIcon icon={faChevronDown} />
		</FilterDropdownButton>
	);
};

export default CampusSelectorButton;
